//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

export enum FacebookPageAudienceGenderOptions {
  ALL = 'all',
  FEMALE = 'female',
  MALE = 'male',
  UNSPECIFIED = 'unspecified',
}

export const FACEBOOK_AUDIENCE_GENDER_LABELS = {
  [FacebookPageAudienceGenderOptions.ALL]: 'All',
  [FacebookPageAudienceGenderOptions.FEMALE]: 'Female',
  [FacebookPageAudienceGenderOptions.MALE]: 'Male',
  [FacebookPageAudienceGenderOptions.UNSPECIFIED]: 'Unspecified',
};

export const FACEBOOK_AUDIENCE_GENDER_COLORS = {
  [FacebookPageAudienceGenderOptions.ALL]: '',
  [FacebookPageAudienceGenderOptions.FEMALE]: theme.colors.blue2,
  [FacebookPageAudienceGenderOptions.MALE]: theme.colors.blue3,
  [FacebookPageAudienceGenderOptions.UNSPECIFIED]: theme.colors.blue1,
};

export enum FacebookPageAudienceLocationOptions {
  CITIES = 'cities',
  COUNTRIES = 'countries',
}

export const FACEBOOK_AUDIENCE_LOCATION_LABELS = {
  [FacebookPageAudienceLocationOptions.CITIES]: 'Top Cities',
  [FacebookPageAudienceLocationOptions.COUNTRIES]: 'Top Countries',
};

export enum FacebookPageAudienceGraphStats {
  GAINED = 'fansGained',
  LOST = 'fansLost',
  CHANGE = 'changeInFans',
  TOTAL = 'totalFans',
}

export const FACEBOOK_AUDIENCE_GRAPH_LABELS = {
  [FacebookPageAudienceGraphStats.GAINED]: 'New Fans',
  [FacebookPageAudienceGraphStats.LOST]: 'Lost Fans',
  [FacebookPageAudienceGraphStats.CHANGE]: 'Change in Fans',
  [FacebookPageAudienceGraphStats.TOTAL]: 'Total Fans',
};

export const FacebookAudienceStatBubbleTitle = {
  NewFans: 'New Fans',
  LostFans: 'Lost Fans',
  ChangeInFans: 'Change in Fans',
};

export const FacebookAudienceStatBubbleTooltips = {
  NewFans:
    'Number of users who have "liked" your page over the selected time period.',
  LostFans:
    'Number of users who have "unliked" your page over the selected time period.',
  ChangeInFans:
    'Net change in users who have "liked" your page over the selected time period.',
};
